import { useLightMode } from '@/hooks/useLightMode'
import { Controller, ControllerRenderProps } from 'react-hook-form'

import { Box, FormErrorMessage, Input, Text } from '@chakra-ui/react'
import { FormControl as ChakraFormControl } from '@chakra-ui/react'

import { FormInputControlV2IProps } from './types'

export const FormInputControlV2 = ({
  id,
  control,
  defaultValue,
  placeholder = '',
  label,
  showRequired = false,
  requiredLabel = 'REQUIRED',
  rules,
  isInvalid = false,
  errorMessage,
  isDisabled = false,
  dataTestId,
  width = '100%',
}: FormInputControlV2IProps) => {
  const mode = useLightMode()
  const bgColor = `bg.input.${mode}`
  const textColor = `text.primary.${mode}`
  const labelColor = `text.input-value.${mode}`
  const borderHover = `border.input-hover.${mode}`
  const borderFocus = `border.input-focus.${mode}`

  return (
    <ChakraFormControl
      data-testid={dataTestId}
      isDisabled={isDisabled}
      width={width}
    >
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={id}
        render={({ value, onChange }: ControllerRenderProps) => (
          <Box
            bgColor={bgColor}
            borderColor={isInvalid ? '#A62630' : 'transparent'}
            borderWidth='1px'
            position='relative'
            px='12px'
            py='8px'
            sx={{
              '&:hover:not(:focus-within)': {
                borderColor: isInvalid ? '#A62630' : borderHover,
              },
              '&:focus-within': {
                borderColor: borderFocus,
              },
            }}
          >
            {label && (
              <Text
                color={labelColor}
                fontSize='10px'
                fontWeight='500'
                mb='8px'
                opacity={0.8}
                textTransform='uppercase'
              >
                {label}
              </Text>
            )}
            <Input
              _focus={{ boxShadow: 'none', outline: 'none' }}
              _placeholder={{
                color: labelColor,
              }}
              bg='transparent'
              border='none'
              color={textColor}
              fontSize='14px'
              fontWeight='400'
              h='auto'
              isDisabled={isDisabled}
              onChange={(e) => onChange(e.target.value)}
              p='0'
              placeholder={placeholder}
              value={value || ''}
            />
            {showRequired && (
              <Text
                color={`text.input-value.${mode}`}
                fontSize='10px'
                fontWeight='500'
                letterSpacing='0.5px'
                position='absolute'
                right='12px'
                textTransform='uppercase'
                top='8px'
              >
                {requiredLabel}
              </Text>
            )}
          </Box>
        )}
        rules={rules}
      />
      <FormErrorMessage data-testid='form-control-input-v2-error'>
        {errorMessage}
      </FormErrorMessage>
    </ChakraFormControl>
  )
}
